import { StyleSheet, Text, View } from 'react-native'
import React from 'react'

type SolidDividerProps = {
    width?: any,
    height?: any,
    backgroundColor?: string,
    style?: any
}

const SolidDivider:React.FC<SolidDividerProps> = ({
    width: width,
    height: height,
    backgroundColor: backgroundColor,
    style
}) => {
  return (
    <>
        <View style={[{ width, height , backgroundColor}, style]} />
    </>
  )
}

export default SolidDivider

const styles = StyleSheet.create({})